var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m426.413 85.587c-45.519-45.519-106.039-70.587-170.413-70.587-64.373 0-124.894 25.068-170.413 70.587s-70.587 106.039-70.587 170.413c0 64.373 25.068 124.894 70.587 170.412 45.519 45.52 106.04 70.588 170.413 70.588 64.374 0 124.894-25.068 170.413-70.588 45.519-45.518 70.587-106.039 70.587-170.412 0-64.374-25.068-124.894-70.587-170.413zm-170.413 379.413c-115.243 0-209-93.757-209-209s93.757-209 209-209 209 93.757 209 209-93.757 209-209 209zm77.813-344.887c-15.559 0-30.156 6.028-41.101 16.974l-151.195 151.194c-2.163 2.163-3.661 4.9-4.316 7.889l-16.718 76.293c-1.167 5.327.459 10.882 4.316 14.738 3.033 3.033 7.116 4.687 11.313 4.687 1.14 0 2.288-.122 3.425-.371l76.292-16.718c2.988-.654 5.726-2.152 7.889-4.315l151.195-151.195c22.663-22.664 22.663-59.539 0-82.202-10.945-10.946-25.541-16.974-41.1-16.974zm-129.409 224.431-47.315 10.368 10.368-47.316 112.128-112.128 36.947 36.948zm147.883-147.882-13.127 13.127-36.948-36.948 13.127-13.127c4.901-4.901 11.462-7.601 18.473-7.601s13.572 2.7 18.474 7.601c10.187 10.186 10.187 26.761.001 36.948z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1dc5d0552a2402accd7f40dbb94e9925.svg";
export { ForwardRef as ReactComponent };